var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"change":(val) => _vm.$emit('input', val)}},'el-checkbox',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }